module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11DC2Wb/tc-custom/9781504071697.jpg?1737679970805",
      "alt": "This image is the cover for the book Sealed with a Death, The Lucie Musilova Thillers"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sealed with a Death, The Lucie Musilova Thillers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A British secret agent is investigating the disappearance of European women across the UK in this tense spy thriller.")]), _c('br'), _c('br'), _vm._v("Barely escaping her last mission with her life, Lucie Musilova has recovered from her wounds, but her reputation with British intelligence is still damaged. Now she is assigned a low-profile case to regain her superior’s trust. All across the UK, women have been disappearing. All are European nationals, and all have been ignored by a disinterested media and the politically restrained police force. "), _c('br'), _c('br'), _vm._v("When a body is discovered and the case grows ever more personal, Lucie finds herself entwined in the seedy world of government-sanctioned prostitution. She must fight corruption and far right violence to uncover the truth. But with her mentor injured and assassins on her tail, Lucie will have to use all her wits to avoid becoming the final seal in a deal for the country’s very soul . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James Silvester\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("James's books combine his love of Cold War spy fiction with his passion for the Czech Republic and Slovakia. A former Mod DJ, James has been recognised as a voice of 'Brex-Lit' and is a staunch member of the 48%. Away from thrillers, he is a contributing editor of unofficial Doctor Who charity anthologies.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0